// @flow
export { default } from './Ghost';
